module.exports = __webpack_public_path__ + "static/heart-4e1be369840be0fbc26696c208d915b9.jpg";